import Currency from 'components/Currency/Currency';
import React, { useMemo } from 'react';
import DataTable from 'components/DataTable';
import { tableStyles } from 'css/tableStyles';
import { Modal } from 'react-bootstrap';
import InventoryItemId from 'components/InventoryItemId';
import _ from 'lodash';
import QuantityGraph from 'pages/inventory-items/list/quantityGraph';

const ItemsTableModal = (props) => {
  const { toggleModal, data } = props;

  const handleClose = () => {
    toggleModal();
  };

  const columns = useMemo(() => [
    {
      name: 'ItemID',
      selector: 'objectId',
      sortable: false,
      width: '150px',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <InventoryItemId itemDetails={row} />
      ),
    },
    {
      name: 'Quantity Graph',
      width: '200px',
      cell: ({ stockBefore7Days, stock }) => {
        if (stockBefore7Days && stock) {
          return <QuantityGraph data={[[0, stockBefore7Days], [stock, stock]]} />;
        } else {
          return null;
        }
      },
    },
    {
      name: 'Item Name',
      selector: 'name',
      sortable: false,
      width: '150px',
      cell: row => (
        <div>{row?.name}</div>
      ),
    },
    {
      name: 'Category',
      // selector: 'category.description',
      cell: row => (
        <div>{row.category?.description || ''}</div>
      ),
      sortable: false,
    },
    {
      name: 'Price',
      selector: 'price',
      sortable: false,
      // eslint-disable-next-line react/display-name
      format: (row) => (<Currency amount={parseFloat(row.price?.toFixed(2))} default={'-'} />),
    },
    {
      name: 'Cost',
      selector: 'weightedAvgCost',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => (row.weightedAvgCost ? <Currency amount={parseFloat(row.weightedAvgCost.toFixed(2))} /> : '-'),
    },
    {
      name: 'Margin',
      selector: 'weightedAvgCost',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => (row.weightedAvgCost ? <Currency amount={parseFloat((row.price - row.weightedAvgCost).toFixed(2))} /> : '-'),
    },
    {
      name: 'Margin %',
      selector: 'weightedAvgCost',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => {
        if (row.weightedAvgCost) {
          const marginPercent = (row.price - row.weightedAvgCost) * 100 / row.weightedAvgCost;
          return <div>{marginPercent.toFixed(2)}</div>;
        } else {
          return '-';
        }
      },
    },
    {
      name: 'Quantity',
      selector: 'stock',
      sortable: false,
    },
    {
      name: 'Probability',
      selector: 'probability',
      sortable: true,
      // eslint-disable-next-line react/display-name
      format: row => _.isNil(row.probability) ? <div>{'N/A'}</div> : <div>{row.probability}</div>,
    },
    {
      name: 'Unfulfilled Stock',
      selector: 'unfulfilledStock',
      sortable: false,
      format: row => row.unfulfilledStock ? row.unfulfilledStock : '0',
    },
    {
      name: 'Unit',
      selector: 'unit',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => (
        <div>{row.unit?.description || ''}</div>
      ),
    },
    {
      name: 'Active',
      selector: 'active',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => {
        if (typeof row.active !== 'undefined') {
          return <div>{row.active.toString()}</div>;
        } else {
          return <div>{'N/A'}</div>;
        }
      },
    },
    {
      name: 'Origin',
      selector: 'origin',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => (
        <div>{row.origin || 'None'}</div>
      ),
    },
    {
      name: 'Promotional',
      selector: 'isPromotional',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => {
        if (typeof row.isPromotional !== 'undefined') {
          return <div>{row.isPromotional.toString()}</div>;
        } else {
          return <div>{'N/A'}</div>;
        }
      },
    },
    {
      name: 'Featured',
      selector: 'isFeatured',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => {
        if (typeof row.isFeatured !== 'undefined') {
          return <div>{row.isFeatured.toString()}</div>;
        } else {
          return <div>{'N/A'}</div>;
        }
      },
    },
  ], []);

  return (
    <Modal show={true} animation={false} size='lg' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Items</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ width: '100%' }}>
          <DataTable
            keyField="objectId"
            columns={columns}
            noHeader={true}
            data={data}
            highlightOnHover={true}
            customStyles={tableStyles}
            pagination={true}
            paginationPerPage={8}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ItemsTableModal;